import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type ServiceDebit from '../../interfaces/pieces/mouvements/serviceDebit';

export const getServicesDebit = (
  params: URLSearchParams,
) => request.get<unknown, TemplateRequestGet<ServiceDebit>>(
  `/api/finances/comptabilite/piecescomptables/servicesDebit?${params.toString()}`,
);

export const createServiceDebit = (
  serviceDebit: Omit<ServiceDebit, 'identifiant'>,
) => request.post<Omit<ServiceDebit, 'identifiant'>, ServiceDebit>(
  '/api/finances/comptabilite/piecescomptables/servicesDebit',
  serviceDebit,
);

export default getServicesDebit;
